"use client";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setLanguage } from "@/store/slices/languageSlice";
import enHeader from "@/locales/en/header.json";
import frHeader from "@/locales/fr/header.json";
import enSidebar from "@/locales/en/sidebar.json";
import frSidebar from "@/locales/fr/sidebar.json";
import enUserManagement from "@/locales/en/usermanagement.json";
import frUserManagement from "@/locales/fr/usermanagement.json";
import enCommon from "@/locales/en/common.json";
import frCommon from "@/locales/fr/common.json";
import enProfile from "@/locales/en/profile.json";
import frProfile from "@/locales/fr/profile.json";
import enRole from "@/locales/en/role.json";
import frRole from "@/locales/fr/role.json";
import enLien from "@/locales/en/lien.json";
import frLien from "@/locales/fr/lien.json";
import enDashboard from "@/locales/en/dashboard.json";
import frDashboard from "@/locales/fr/dashboard.json";
import frValidation from "@/locales/fr/validation.json";
import frProvinces from "@/locales/fr/provinces.json";
import enValidation from "@/locales/en/validation.json";
import enProvinces from "@/locales/en/provinces.json";
import enconfig from "@/locales/en/config.json";
import frconfig from "@/locales/fr/config.json";
import enNotification from "@/locales/en/notification.json";
import frNotification from "@/locales/fr/notification.json";

export type Language = "en" | "fr";

export const useLanguage = () => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state?.language?.language || "en");

  const setLanguageHandler = (lang: Language) => {
    dispatch(setLanguage(lang));
  };

  const translations: any = {
    en: {
      header: enHeader,
      sidebar: enSidebar,
      usermanagement: enUserManagement,
      common: enCommon,
      profile: enProfile,
      role: enRole,
      lien: enLien,
      dashboard: enDashboard,
      validation: enValidation,
      provinces: enProvinces,
      config: enconfig,
      notification: enNotification,
    },
    fr: {
      header: frHeader,
      sidebar: frSidebar,
      usermanagement: frUserManagement,
      common: frCommon,
      profile: frProfile,
      role: frRole,
      lien: frLien,
      dashboard: frDashboard,
      validation: frValidation,
      provinces: frProvinces,
      config: frconfig,
      notification: frNotification,
    },
  };

  const t = (key: string = ""): string => {
    const [namespace, ...rest] = key?.split(".");
    const dict =
      translations[language][
        namespace as keyof (typeof translations)[typeof language]
      ];
    let value: any = dict;
    for (const k of rest) {
      if (value && typeof value === "object" && k in value) value = value[k];
      else return key;
    }
    return typeof value === "string" ? value : key;
  };

  return {
    language,
    setLanguage: setLanguageHandler,
    t,
    isFrench: language === "fr",
  };
};
